/* eslint-disable no-console */

import { register } from "register-service-worker";
import { EventBus } from "@/plugins/eventBus";

// فاصله زمانی بررسی خودکار وجود نسخه جدید روی سرور
const UPDATE_CHECK_INTERVAL = 30 * 60 * 1000;
const ACTIVATION_TIMEOUT = 5000;

// وضعیت مشترک سرویس‌ورکر؛ کامپوننت UpdateSnackbar از آن می‌خواند
export const swState = {
  registration: null, // registration ای که نسخه جدیدش در حالت waiting است
  refreshing: false, // فقط رفرشی که کاربر خواسته مجاز است
  reloading: false,
};

function reloadOnce() {
  if (swState.reloading) return;
  swState.reloading = true;
  window.location.reload();
}

async function hardReload() {
  if (swState.reloading) return;
  try {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(registrations.map((r) => r.unregister()));
    if ("caches" in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map((key) => caches.delete(key)));
    }
  } finally {
    reloadOnce();
  }
}

export function applyUpdate() {
  swState.refreshing = true;

  const waiting = swState.registration && swState.registration.waiting;
  if (!waiting) {
    reloadOnce();
    return;
  }

  waiting.addEventListener("statechange", () => {
    if (waiting.state === "activated") reloadOnce();
  });
  // Workbox شنونده این پیام را خودش تولید می‌کند و skipWaiting را صدا می‌زند
  waiting.postMessage({ type: "SKIP_WAITING" });

  setTimeout(hardReload, ACTIVATION_TIMEOUT);
}

if (process.env.NODE_ENV === "production") {
  if ("serviceWorker" in navigator) {
    // پس از فعال شدن سرویس‌ورکر جدید، یک‌بار صفحه بارگذاری مجدد می‌شود
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (swState.refreshing) {
        reloadOnce();
        return;
      }
      EventBus.$emit("sw-updated", swState.registration);
    });
  }

  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log(
        "App is being served from cache by a service worker.\n" +
          "For more details, visit https://goo.gl/AFskqB",
      );
    },
    registered(registration) {
      console.log("Service worker has been registered.");
      setInterval(() => registration.update(), UPDATE_CHECK_INTERVAL);
    },
    cached() {
      console.log("Content has been cached for offline use.");
    },
    updatefound() {
      console.log("New content is downloading.");
    },
    updated(registration) {
      console.log("New content is available.");
      swState.registration = registration;
      EventBus.$emit("sw-updated", registration);
    },
    offline() {
      console.log(
        "No internet connection found. App is running in offline mode.",
      );
    },
    error(error) {
      console.error("Error during service worker registration:", error);
    },
  });
}
